export const isReactSnap = () => {
  return (
    typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap"
  );
};
